import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  useReportType,
  useReportTypeUpload,
} from "../../../common/CommonQueries";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useState } from "react";
import { useFetchContext } from "../../../common/FetchContext";
import {
  UseChecklistUploadData,
  usePostParseDocument,
  usePostReportDocument,
} from "../../../common/services/fileServices";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { useReportTemplateId } from "../../projectManagementQueries";
import CircularProgress from "@material-ui/core/CircularProgress";

export const ChecklistUpload = () => {
  const [reportType, setReportType] = useState<number | null>(null);
  const [selectedPqpVersion, setSelectedPqpVersion] = useState<string | null>(
    null,
  );
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const { authAxios } = useFetchContext();

  const history = useHistory();

  // const { mutate: parseDocument, isLoading } = usePostParseDocument();

  const { mutate: UploadCheckList, isLoading } = UseChecklistUploadData();

  const { mutate: getReportTemplateId, isLoading: isLoadingTemplateId } =
    useReportTemplateId();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) return;

    setSelectedFile(file);
  };

  const handleSubmit = () => {
    if (!reportType) {
      alert("Please select Report Type");
      return;
    }

    if (!selectedPqpVersion) {
      alert("Please select PQP Version");
      return;
    }

    if (!selectedFile) {
      alert("Please choose a file");
      return;
    }

    UploadCheckList(
      {
        authAxios,
        file: selectedFile,
        report_type_definition_id: reportType,
        version: selectedPqpVersion,
      },
      {
        onSuccess: (response) => {
          console.log("Submitted Response:", response);
          const template_id = response.document_template_id;
          toast.success("Checklist uploaded successfully.");
          //   history.push(
          //     `/reports/report_document_upload/report_preview_editor/${template_id}`,
          //   );

          setSelectedFile(null);
          setSelectedPqpVersion(null);
        },
        onError: (error: any) => {
          console.error(error);

          toast.error(
            error?.message ||
            error?.response?.data?.msg ||
            "Failed to upload document.",
          );
        },
      },
    );
  };

  const {
    error: errorReportType,
    data: ReportType,
    isLoading: isLoadingReportType,
    isError: isErrorReportType,
  } = useReportTypeUpload(selectedPqpVersion);

  const handleEdit = () => {
    if (!reportType) {
      toast.error("Report Type is not selected.");
      return;
    }

    getReportTemplateId(reportType.toString(), {
      onSuccess: (response) => {
        console.log("Template ID response:", response);

        const templateId = response.template_id;

        if (!templateId) {
          toast.error("Document template ID not found.");
          return;
        }

        // history.push(
        //   `/reports/report_document_upload/report_preview_editor/${templateId}`,
        // );
      },
      onError: (error: any) => {
        console.error("Failed to get template ID:", error);

        toast.error(
          error?.response?.data?.msg ||
          error?.message ||
          "Failed to get document template.",
        );
      },
    });
  };

  const selectedReportType = ReportType?.find(
    (item: any) => item.id === reportType,
  );

  const isActiveReportType = selectedReportType?.is_active === true;

  const pqpVersion = ["V11", "V12"];

  const handleReportType = (value: any) => {
    setReportType(value);
  };

  return (
    <>
      <div>
        <Container maxWidth="sm">
          <Grid
            container
            style={{ marginTop: 25 }}
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              <Autocomplete
                options={pqpVersion}
                value={selectedPqpVersion}
                onChange={(event, newValue) => {
                  setSelectedPqpVersion(newValue);
                  setReportType(null);
                  setSelectedFile(null);
                }}
                getOptionLabel={(option) => option || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="PQP Version"
                    margin="dense"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                disabled={!selectedPqpVersion}
                options={ReportType || []}
                getOptionLabel={(option: any) => option.name || ""}
                // getOptionDisabled={(option: any) => option.is_active === true}
                value={
                  ReportType?.find((item: any) => item.id === reportType) ??
                  null
                }
                onChange={(event, newValue: any) => {
                  handleReportType(newValue?.id ?? null);
                  setSelectedFile(null);
                }}
                loading={isLoadingReportType}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Checklist Type"
                    margin="dense"
                    fullWidth
                  />
                )}
              />
            </Grid>

            {reportType && selectedPqpVersion && (
              <Grid item xs={12} style={{ marginTop: 20 }}>
                {isActiveReportType ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Typography variant="h6">
                      {selectedReportType?.name}
                    </Typography>

                    {isLoadingTemplateId ? (
                      <CircularProgress size={20} color="primary" />
                    ) : (
                      <EditIcon
                        color="primary"
                        style={{ cursor: "pointer" }}
                        onClick={handleEdit}
                      />
                    )}
                  </div>
                ) : (
                  <>
                    <input
                      accept=".doc,.docx,.xls,.csv,.xlsx"
                      style={{ display: "none" }}
                      id="upload-file"
                      type="file"
                      onChange={handleFileChange}
                    />

                    <label htmlFor="upload-file" style={{ cursor: "pointer" }}>
                      <Typography variant="h5" color="primary">
                        Upload Checklist File
                        <img
                          src="/file_upload.svg"
                          alt="Upload"
                          width="30"
                          height="30"
                          style={{
                            marginLeft: 10,
                            verticalAlign: "middle",
                          }}
                        />
                      </Typography>
                    </label>

                    {selectedFile && (
                      <Typography style={{ marginTop: 20 }}>
                        {selectedFile.name}
                      </Typography>
                    )}
                  </>
                )}
              </Grid>
            )}

            {selectedFile && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 40 }}
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </Button>
              </>
            )}
          </Grid>
        </Container>
      </div>
    </>
  );
};
